module.exports = __webpack_public_path__ + "img/boat.0dd6054f.svg";